<script setup>
import { validationCheck } from '@utils'

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useStaffItem } from '@store/staffItem'
const $staffItem = useStaffItem()

import { useRouter } from 'vue-router'
const router = useRouter()

import Main from './Main.vue'
import EditProfile from '../staff/EditProfile.vue'
import ButtonBack from './ButtonBack.vue'
import ButtonSubmit from './ButtonSubmit.vue'
import { onMounted } from 'vue'

const saveStaffProfile = () => {
    $staffItem.submit('publish', true)
}

onMounted(async () => {
    $staffItem.resetStaff()
    $staffItem.mountStaffItem()
})
</script>

<template>
    <Main :title="`Add Your ${$settings.labels.staff?.singular}`" :progress="100">
        <EditProfile />
        <ButtonSubmit text="Publish" @click="saveStaffProfile()" />


        <template #footer>
            <!-- <ButtonBack @click="router.push({ name: 'dashboard' })" /> -->
        </template>
    </Main>
</template>